import React, { ReactNode } from 'react';
import classnames from 'classnames';
import { IconX } from '@pentabd/icons';
import classNames from 'classnames';

export interface TagProps {
  testId?: string;
  testIdLabel?: string;
  size?: 'sm' | 'md' | 'lg';
  label?: string | ReactNode;
  startIconType?: 'icon' | 'dot';
  startIcon?: ReactNode;
  endIconType?: 'close' | 'count';
  endIcon?: ReactNode | number;
  onClickClose?: () => void;
  className?: string;
  disabled?: boolean;
  isTextBreak?: boolean;
}
const Tag = ({
  testId,
  testIdLabel,
  size = 'md',
  label,
  startIconType,
  endIconType,
  endIcon,
  startIcon,
  onClickClose,
  className,
  disabled,
  isTextBreak = true,
}: TagProps) => {
  return (
    <div
      data-testid={testId}
      className={classnames('tags', 'rounded', `tags-${size}`, className)}
    >
      {startIconType == 'dot' && <div className="tags-dot" />}
      {startIconType == 'icon' && startIcon}

      {label ? (
        <div
          data-testid={testIdLabel}
          className={classNames('tags-label', { 'text-nowrap': isTextBreak })}
        >
          {label}
        </div>
      ) : null}

      {!disabled && endIconType == 'close' && (
        <div
          onClick={onClickClose}
          className="d-flex align-items-center tags-close pointer"
        >
          <IconX size="20" />
        </div>
      )}

      {endIconType == 'count' && <div className="tags-number">{endIcon}</div>}
    </div>
  );
};
export default Tag;
